<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ cardTitle }}</h4>
        <b-alert v-show="alertShow" show dismissible :variant="alertVariant">{{
          alertMsg
        }}</b-alert>
        <p class="card-title-desc">
          {{ description }}
        </p>
        <form class="needs-validation" @submit.prevent="FormSubmit()">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Σχόλια</label>
                <input id="validationCustom01" type="text" class="form-control" placeholder="Σχόλια"
                  v-model="comments" />
              </div>
              <div class="mb-3">
                <label class="mt-3">Τύπος Άδειας*</label>
                <multiselect required v-model="holidayTypeValue" :options="holidayTypesOptions"
                  placeholder="Επιλέξτε Τύπο" selectLabel="Eπιλογή Τύπο" selectedLabel="Επιλέχθηκε"
                  deselectLabel="Αποεπιλογή"></multiselect>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="mt-3">Από*</label>
                    <b-form-input id="example-input" v-model="startDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="mt-3">Μέχρι*</label>
                    <b-form-input id="example-input" v-model="endDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <p v-if="startDate && endDate">{{ getHolidayDiffDates }}</p>
          </div>

          <button class="btn btn-primary" type="submit">
            Ολοκλήρωση
          </button>
        </form>
      </div>
    </div>
    <!-- end card -->
  </div>
</template>

<script>
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  components: {
    Multiselect,
  },
  props: {
    cardTitle: String,
    description: String,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      holidayTypes: [],
      holidayTypeValue: "",
      comments: "",
      alertShow: false,
      alertVariant: "",
      alertMsg: "",
    };
  },
  mounted() {
    this.fetchHolidayTypes();
  },
  computed: {
    holidayTypesOptions() {
      return this.holidayTypes.map((e) => e.title);
    },
    getHolidayDiffDates() {
      if (this.startDate != null && this.endDate != null) {
        const startdate = moment(this.startDate);
        const enddate = moment(this.endDate);
        const result = moment.duration(enddate.diff(startdate)).asDays();
        return result > 0 ? `Ημέρες άδειας: ${result}` : "";
      } else {
        return "";
      }
    },
  },
  methods: {
    fetchHolidayTypes() {
      session.get("api/holidays/holiday-type-list/").then((resp) => {
        this.holidayTypes = resp.data;
      });
    },
    FormSubmit() {
      const holidayTypesId = this.holidayTypes
        .filter((e) => e.title === this.holidayTypeValue)
        .map((item) => item.id)[0];

      if (!this.holidayTypeValue) {
        alert("Παρακαλώ επιλέξτε τύπο άδειας");
        return;
      }
      if (!this.startDate || !this.endDate) {
        alert("Παρακαλώ συμπληρώστε τις ημερομηνίες");
        return;
      }
      if (this.startDate > this.endDate) {
        alert("Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης");
        return;
      }

      session
        .post("api/person/holiday/create/", {
          holidays_start_date: this.startDate,
          holidays_end_date: this.endDate,
          comments: this.comments,
          person: this.$route.params.id,
          holiday_type: holidayTypesId,
        })
        .then(() => {
          this.alertShow = !this.alertShow;
          this.alertVariant = "success";
          this.alertMsg = "Προστέθηκε επιτυχώς";
          setTimeout(() => {
            this.$emit("holidayCreated");
          }, 1500);
        })
        .catch((e) => {
          this.alertShow = !this.alertShow;
          this.alertVariant = "danger";
          this.alertMsg = e.response.data;
        });
    },
  },
};
</script>
